import { Form, Formik } from 'formik';
import InputText from '../../../components/input-text/inputText';
import ModalComponent from '../../../components/modal/modal';
import ModalBodyComponent from '../../../components/modal/modalBodyComponent';
import ModalFooterComponent from '../../../components/modal/modalFooterComponent';
// eslint-disable-next-line camelcase
import {
  CompanyBankService,
  ParticipantBankService,
  type Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_CompanyBankForViewDto,
} from '@wealthlane/api-services/wealthlane-finance-integration-service';
import Heading from '../../../components/typography';
import FormSelect from '../../../components/dropdown/formSelect';
import { YesNoOptions } from '../../../constants/common';
import InitialValuesForm from '../../../constants/initialValues';
import {
  useGetBankAccountType,
  useGetBankRoutingType,
  useWealthlaneFinanceIntegrationApi,
} from '../../../hooks';
import { ModalStatusType } from '../../../types/common';
import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastComponent from '../../../components/toast';
import { useQueryClient } from 'react-query';
import { MANUAL_BANK_ACCOUNT_FORM } from '../../../utils/validations/validations';

interface ChooseBankAccountMethodType {
  isModalOpen: boolean;
  closeModal: () => void;
  modalLoading: boolean;
  // eslint-disable-next-line camelcase
  initialData?: any;
  id?: string;
}

const ChooseBankAccountMethod = ({
  isModalOpen,
  closeModal,
  // initialData,
  modalLoading,
  id,
}: ChooseBankAccountMethodType): JSX.Element => {
  const { handleRequest } = useWealthlaneFinanceIntegrationApi();
  const { data: accountTypeOptions } = useGetBankAccountType(handleRequest);
  const { data: routingTypeOptions } = useGetBankRoutingType(handleRequest);
  const [loading, setLoading] = useState<boolean>();
  const queryClient = useQueryClient();

  const handleSubmit = (values: any): void => {
    setLoading(true);
    /*  values?.id
      ? handleRequest(
          ParticipantBankService.putApiFinanceIntegrationApiAppParticipantBankManualBankAccount(
            values
          )
        )
          .then((data: any) => {
            if (data) {
              toast.success(
                <ToastComponent label='Success' message='Manual Bank Account edited.' />
              );
              queryClient.invalidateQueries('getCompanyBankList');
              setLoading(false);
              closeModal();
            }
          })
          .catch((error: any) => {
            console.log('error', error);
            setLoading(false);
          })
          .finally(() => {
            setLoading(false);
          }) */
    handleRequest(
      CompanyBankService.postApiFinanceIntegrationApiAppCompanyBankRegisterManualBankAccount(values)
    )
      .then((data: any) => {
        if (data) {
          toast.success(<ToastComponent label='Success' message='Manual Bank Account created.' />);
          queryClient.invalidateQueries('getCompanyBankList');
          setLoading(false);
          closeModal();
        }
      })
      .catch((error: any) => {
        console.log('error', error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={InitialValuesForm?.externalBankAccount}
      validationSchema={MANUAL_BANK_ACCOUNT_FORM}
      onSubmit={(values) => {
        handleSubmit(values);
      }}>
      {({ touched, handleChange, errors, setFieldValue, setFieldTouched, values }) => {
        return (
          <ModalComponent
            show={isModalOpen}
            closeModal={closeModal}
            loading={modalLoading}
            title={'Set up Bank Accounts'}
            size='sm'
            id={id}
            children={
              <Form id="chooseBankMethodForm">
                <ModalBodyComponent id="modalBody">
                  <div className='mb-4 ' id="methodSelectionContainer">
                    <Heading title={'Manual'} variant='h5' className='mb-4' id="manualHeading" />

                    <div className='flex flex-col gap-4' id="manualFormFields">
                      <InputText
                        type='text'
                        inputType='View'
                        label='Account Holder Name'
                        name='accountName'
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        className='mb-0'
                        required
                        id="accountName"
                      />
                      <InputText
                        type='text'
                        inputType='View'
                        label='Account Nick Name'
                        name='accountNickName'
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        className='mb-0'
                        required
                        id="accountNickName"
                      />
                      <FormSelect
                        type='text'
                        label='Routing Type'
                        name='routingTypeId'
                        containerClassName='mb-0'
                        viewName='routingTypeId'
                        onChange={(e: string) => handleChange(e as string)}
                        errors={errors}
                        touched={touched}
                        options={routingTypeOptions}
                        values={values}
                        arrValue={values?.routingTypeId}
                        setFieldValue={setFieldValue}
                        required
                        id="routingTypeId"
                      />
                      <InputText
                        type='text'
                        inputType='View'
                        label='Routing Number'
                        name='routingNumber'
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        className='mb-0'
                        required
                        id="routingNumber"
                      />
                      <FormSelect
                        type='text'
                        label='Account Type'
                        name='accountTypeId'
                        containerClassName='mb-0'
                        viewName='accountTypeId'
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        options={accountTypeOptions}
                        values={values}
                        arrValue={values?.accountTypeId}
                        setFieldValue={setFieldValue}
                        required
                        id="accountTypeId"
                      />

                      <InputText
                        type='text'
                        inputType='View'
                        label='Account Number'
                        name='accountNumber'
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        className='mb-0'
                        required
                        id="accountNumber"
                      />

                      <InputText
                        type='text'
                        inputType='View'
                        label='Institution Name'
                        name='institutionName'
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        className='mb-0'
                        required
                        id="institutionName"
                      />
                    </div>
                  </div>
                </ModalBodyComponent>
                <ModalFooterComponent
                  modalStatus={'Add'}
                  isLoading={loading}
                  // addDisable={loading}
                  onCloseModal={() => {
                    closeModal();
                  }}
                  isEditShow={false}
                  id="modalFooter"
                // valueChanged={_.isEqual(values, initialData.data)}
                />
              </Form>
            }
          />
        );
      }}
    </Formik>
  );
};

export default ChooseBankAccountMethod;
